import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Button from 'b2b-ui-components-lib/lib/components/button';
import React, { useContext, useEffect, useRef, useState } from 'react';
import RoundLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
import FileUpload from './fileUpload';
import './index.scss';
import {
  DEFAULT_TOAST_MSG,
  DOCUMENT_TYPE_ENUM,
  ERROR_TOAST,
  KDM_TOAST_MSG,
  MULTI_SITE_MODULE_ID,
  SUCCESS_TOAST,
  SUMMARY_AUTH_TOKEN,
  WARNING_TOAST
} from 'home/view/manage-feasibility/constants';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { deleteDocumentsForSummary, fetchOrder, fetchOrderDetails, sendPhotoLinkAOI, sendQuotationAOI } from 'home/view/manage-feasibility/services';
import { getDefaultFiles } from './formControl';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import UploadDocuments from './documents/upload-documents';
import CustomModalKdm from './customModalKdm';
import { AppContext } from 'App';
import KdmImage from './documents/kdm-image-card';
import CustomModalEmail from './customModalEmail';
import kdmDummyImage from '../kdmDetails/documents/kdm.svg';

function CompanyGstDocuments({
  order = {},
  setIsSaveBtnDisabled = false,
  updatedEmail = '',
  setUpdatedEmail = () => {},
  fetchOrderFn,
  companyGstValidation,
  setCompanyGstValidation,
  kdmAccordionValidation
}) {
  const options = [
    { id: 'pan', displayName: 'Pan Card' },
    { id: 'aadhaar', displayName: 'Aadhaar Card' }
  ];

  const { toast, setToast } = useContext(AppContext);

  const kdmInformation = order?.lead?.customer?.authorizedSignatory;
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  const [form, setForm] = useState();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [uploadedDoc, setUploadedDoc] = useState({});
  const [kdmImagePresent, setKdmImagePresent] = useState(false);

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  const fileSchemaAadhaarCardFront = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['AADHAAR_FRONT'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };

  const fileSchemaAadhaarCardBack = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['AADHAAR_BACK'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };

  const fileSchemaPanCardFront = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['PAN_FRONT'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };
  const fileSchemaPanCardBack = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['PAN_BACK'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };

  // const fileSchemaVoterCard = {
  //   supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  //   maxFileLimit: 1024 * 1024,
  //   documentNames: ['VOTER_CARD_FRONT', 'VOTER_CARD_BACK'],
  //   documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
  //   allowMultiplePDFs: true
  // };

  // const fileSchemaDrivingLicense = {
  //   supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  //   maxFileLimit: 1024 * 1024,
  //   documentNames: ['DL_FRONT', 'DL_BACK'],
  //   documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
  //   allowMultiplePDFs: true
  // };

  const onSuccessCb = (order) => {
    // uploadedDocsObj(order);
    setUploadedDoc({});
  };

  const fetchKdmLiveImageHandler = async () => {
    const { res, err } = await fetchOrder(orderAuthToken);

    if (res) {
      const authSignatory = res?.data?.result?.documents?.AUTHORIZED_SIGNATORY;
      const kdmLiveImage = authSignatory && authSignatory['KDM'];
      if (kdmLiveImage) {
        setKdmImagePresent(true);
        setKdmImageError(false);
      } else {
        setKdmImageError(true);
      }
    } else if (err) {
    }
  };

  const onFileUpload = (files, type, uploadedFiles) => {
    setForm({ ...form, files });
    if (files) {
      setUploadedFiles(uploadedFiles);
    } else {
      setUploadedFiles([]);
    }
  };

  const uploadedDocsObj = (orderDetails) => {
    console.log(order);
    const authSignDocs = orderDetails?.documents?.AUTHORIZED_SIGNATORY || order?.documents?.AUTHORIZED_SIGNATORY;
    const obj = {};
    Object.keys(authSignDocs).forEach((item) => {
      if (item !== 'KDM') {
        obj[item] = authSignDocs[item];
      }
    });
    setUploadedDoc(obj);
  };

  const handleKDMEditSuccess = (orderRes) => {
    setUpdatedEmail(orderRes?.lead?.customer?.authorizedSignatory?.email);
  };

  const deleteUploadedFiles = async (documentName) => {
    const payload = { documentType: 'COMPANY', documentName };
    try {
      const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);
      if (res) {
        console.log('deleted successfully');
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <React.Fragment>
      <Accordion title="Company GST Documents" isValidated={companyGstValidation} isExpanded={true} autoScrollOnExpand={false}>
        <div className="accordion_body">
          <div className="form_area">
            <div className="row field_row">
              <div className="flg-lg-12 flg-md-12">
                <div className="radio-btn">
                  <UploadDocuments
                    fetchOrderFn={fetchOrderFn}
                    uploadedDoc={uploadedDoc}
                    setUploadedDoc={setUploadedDoc}
                    order={order}
                    selectedDocumentType={selectedOption}
                    setSelectedOption={setSelectedOption}
                    options={options}
                    setCompanyGstValidation={setCompanyGstValidation}
                    kdmImagePresent={kdmImagePresent}
                    setIsSaveBtnDisabled={setIsSaveBtnDisabled}
                    kdmAccordionValidation={kdmAccordionValidation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Accordion>
    </React.Fragment>
  );
}

export default CompanyGstDocuments;
